
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 280 94","preserveAspectRatio":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M136.722.67C52.946-3.903 2.015 13.64 0 93.36h279.978C278.927 5.242 220.499 5.242 136.722.67z"}})])
          )
        }
      }
    